import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { ILink } from 'tbk-components/src/components/Button';
import { IMediaFile } from '../../investors/InvestorKit';
export interface ILinksListItems {
	/**
	 * Item File
	 * @control mediafile
	 */
	file?: IMediaFile;
	/**
	 * Item Link (If No File)
	 */
	link?: ILink;
	/**
	 * Item Label
	 */
	label?: string;
}

export interface ILinksListProps extends IBaseElementProps {
	/**
	 * Links List Heading
	 */
	heading?: string;
	/**
	 * Links List Items
	 */
	items?: ILinksListItems[];
}

/**
 * Links List
 * @block
 * @icon saved
 */
const LinksList: React.FC<ILinksListProps> = ({
	heading,
	items = [],
	id,
	className,
	classNames = [],
}) => {
	return (
		<div
			id={id}
			className={className || cn('calian-links-list', ...classNames)}
		>
			{heading && (
				<h4 className="calian-links-list__heading">{heading}</h4>
			)}
			{items.length > 0 && (
				<ul className="calian-links-list__items">
					{items.map(({ file, link, label }, index) => (
						<li className="calian-links-list__item" key={index}>
							{file?.src ? (
								<a
									href={file.src}
									target="_blank"
									rel="noreferrer noopener"
									className="calian-links-list__file"
								>
									{label && (
										<span className="calian-links-list__label">
											{label}
										</span>
									)}
									{file?.prettySize && (
										<span className="calian-links-list__size">
											({file?.prettySize})
											<span className="calian-links-list__icon icon icon-download"></span>
										</span>
									)}
								</a>
							) : (
								<a
									href={link?.href}
									target={link?.target || null}
									rel={
										link?.target
											? 'noreferrer noopener'
											: null
									}
									className="calian-links-list__link"
								>
									{label && (
										<span className="calian-links-list__label text-charcoal">
											{label}
										</span>
									)}
									<span className="calian-links-list__size">
										<span className="calian-links-list__icon icon icon-arrow-right"></span>
									</span>
								</a>
							)}
						</li>
					))}
				</ul>
			)}
		</div>
	);
};

export default LinksList;
